/**
 * Pack option → featured image switch (main product + featured product)
 * Direct img src swap so it works even when gallery has a single slide.
 */
(function () {
  if (window.__hbPackMediaBound) return;
  window.__hbPackMediaBound = true;

  function applyPackImage(radio) {
    if (!radio || !radio.matches('.pack-options input.variant-radio')) return;

    var productInfo = radio.closest('product-info');
    if (!productInfo) return;

    var imageUrl = radio.getAttribute('data-featured-image');
    var imageSrcset = radio.getAttribute('data-featured-image-srcset');
    var mediaId = radio.getAttribute('data-featured-media-id');
    var sectionId = productInfo.getAttribute('data-section');

    var galleryRoot =
      productInfo.querySelector('.hb-product-gallery__main') ||
      productInfo.querySelector('media-gallery') ||
      productInfo.querySelector('.product__media-wrapper');
    if (!galleryRoot) return;

    var gallerySlider =
      galleryRoot.querySelector('.hb-product-gallery__slider') ||
      galleryRoot.querySelector('[id^="Slider-Gallery"]') ||
      galleryRoot.querySelector('.product__media-list');

    // Activate matching slide when present
    if (gallerySlider && mediaId && sectionId) {
      var targetMediaId = sectionId + '-' + mediaId;
      var slides = Array.prototype.slice.call(
        gallerySlider.querySelectorAll('.product__media-item')
      );
      var targetSlide = gallerySlider.querySelector('[data-media-id="' + targetMediaId + '"]');

      if (targetSlide) {
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide === targetSlide);
        });

        if (window.matchMedia('(max-width: 989px)').matches) {
          gallerySlider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
          if (targetSlide.offsetHeight) {
            gallerySlider.style.height = targetSlide.offsetHeight + 'px';
          }
        }
      }
    }

    // Always force-update main gallery images
    if (!imageUrl) return;

    var imgs = galleryRoot.querySelectorAll(
      '.product__media-item.is-active img, .product__media-item img, .product__media img, .product-media-container img'
    );

    imgs.forEach(function (img) {
      if (img.closest('.thumbnail-list')) return;
      img.setAttribute('src', imageUrl);
      if (imageSrcset) {
        img.setAttribute('srcset', imageSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      if (img.hasAttribute('data-src')) img.setAttribute('data-src', imageUrl);
      if (img.hasAttribute('data-srcset') && imageSrcset) {
        img.setAttribute('data-srcset', imageSrcset);
      }
    });

    galleryRoot.querySelectorAll('.product__media-item.is-active source, .product__media source').forEach(function (source) {
      if (imageSrcset) source.setAttribute('srcset', imageSrcset);
      else source.setAttribute('srcset', imageUrl);
    });
  }

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || !radio.matches) return;
    applyPackImage(radio);
  });
})();
